import React from 'react';

import Chip from '~/components/core/Atomic/Chip/Chip';
import { prettifyKey } from '~/Utils';

import { PROMOTION_STATUS } from './types';

const STATUS_COLOR: Record<string, 'primary' | 'secondary' | 'default'> = {
  [PROMOTION_STATUS.PENDING]: 'default',
  [PROMOTION_STATUS.DEPLOYED]: 'primary',
  [PROMOTION_STATUS.REJECTED]: 'secondary',
  [PROMOTION_STATUS.FAILED]: 'secondary',
  [PROMOTION_STATUS.CANCELLED]: 'secondary',
  [PROMOTION_STATUS.ROLLED_BACK]: 'secondary',
};

/** A status chip for a promotion's lifecycle state, shared by the lists and the detail dialogs. The
 * backend status is lowercase (e.g. `pending`); display it title-cased (`Pending`). */
const PromotionStatusChip: React.FC<{ status: string }> = ({ status }) => (
  <Chip size="small" label={prettifyKey(status)} color={STATUS_COLOR[status] ?? 'default'} />
);

export default PromotionStatusChip;
